<template>
  <div class="watermark-container" :style="containerStyle">
    <!-- 水印层 -->
    <div 
      class="watermark" 
      :style="watermarkStyle"
      v-if="showWatermark"
    ></div>
    <!-- 插槽用于放置需要添加水印的内容 -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Watermark',
  props: {
    // 新增：水印层级
    zIndex: {
      type: Number,
      default: 1000 // 默认值设为较高层级，确保覆盖内容
    },
    // 其他原有属性...
    text: { type: String, default: '' },
    rotate: { type: Number, default: -30 },
    color: { type: String, default: 'rgba(180, 180, 180, 0.3)' },
    fontSize: { type: Number, default: 16 },
    gapX: { type: Number, default: 100 },
    gapY: { type: Number, default: 100 },
    show: { type: Boolean, default: true }
  },
  computed: {
    showWatermark() {
      return this.show && this.text;
    },
    containerStyle() {
      return {
        position: 'absolute',
        overflow: 'hidden'
      };
    },
    watermarkStyle() {
      // 生成SVG水印（逻辑不变）
      const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="${this.gapX}" height="${this.gapY}">
          <text 
            x="${this.gapX / 2}" 
            y="${this.gapY / 2}" 
            fill="${this.color}" 
            font-size="${this.fontSize}" 
            text-anchor="middle" 
            dominant-baseline="middle" 
            transform="rotate(${this.rotate}, ${this.gapX / 2}, ${this.gapY / 2})"
          >
            ${this.text}
          </text>
        </svg>
      `;
      const base64 = btoa(unescape(encodeURIComponent(svg)));
      
      return {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        backgroundImage: `url("data:image/svg+xml;base64,${base64}")`,
        // 新增：通过props控制层级
        zIndex: this.zIndex
      };
    }
  }
};
</script>

<style scoped>
.watermark-container {
  width: 100%;
  height: 100%;
}
</style>